export default __webpack_public_path__ + "static/Rev-Coin-02-6dc40452da37a2138010ffa633962b09.png";